import { config } from 'src/environments/config';

export const environment = {
  production: false,
  appShortName: config.appShortName,
  appFullName: config.appFullName,
  organizationName: config.organizationName,
  companyName: config.companyName,
  companyShortName: config.companyShortName,
  yearReleased: config.yearReleased,
  appVersion: config.appVersion,
  appBuildNumber: config.appBuildNumber,
  server: 'https://mypasm.moe.gov.my/portal',
  api: config.api,
};
